/* @flow */

import React from 'react';
import glamorous from 'glamorous';

type Props = {
  children: any,
  confirmText?: string,
  onClose?: () => void,
  onConfirm?: () => void,
  type: 'danger' | 'info' | 'success' | 'warning',
};

const defaultProps = {
  confirmText: 'Confirm',
  onClose: undefined,
  onConfirm: undefined,
};

const NotificationMessageWrapper = glamorous.div(({ theme }) => ({
  backgroundColor: 'white',
  boxShadow: '0 1px 2px 1px rgba(0,0,0,0.1)',
  fontSize: theme.fontSize.small,
}));

const NotificationMessageTop = glamorous.div(({ theme, type }) => ({
  fontSize: theme.fontSize.small,
  alignItems: 'center',
  backgroundColor: theme.color[type],
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0.25em',
}));

const NotificationMessageMain = glamorous.div({
  padding: '0.75em',
});

const NotificationMessageContent = glamorous.div({color: 'black'});

const NotificationMessageButtonWrapper = glamorous.div({
  paddingTop: '0.5em',
});

const NotificationMessageIcon = glamorous.span(({ type }) => ({
  danger: 'ion-alert',
  info: 'ion-information',
  success: 'ion-checkmark',
  warning: 'ion-alert',
}[type]), {
  color: 'white',
  fontSize: '1.5em',
  lineHeight: 1,
  paddingLeft: '0.375em',
});

const NotificationMessageButton = glamorous('button', {
  withProps: {
    type: 'button',
  },
})(({ theme, type }) => ({
  backgroundColor: theme.color[type],
  borderRadius: 3,
  color: 'white',
  padding: '0.5em 0.75em',
  textTransform: 'uppercase',
}));

const NotificationMessageClose = glamorous('button', {
  withProps: {
    type: 'button',
  },
})({
  color: 'white',
  padding: '0.25em 0.5em',
}, 'ion-close-round');

/* eslint react/prefer-stateless-function: 0 */
function NotificationMessage({
  children,
  confirmText,
  onClose,
  onConfirm,
  type,
}: Props) {
  return (
    <NotificationMessageWrapper>
      <NotificationMessageTop type={type}>
        <NotificationMessageIcon type={type} />
        {onClose && <NotificationMessageClose onClick={onClose} />}
      </NotificationMessageTop>
      <NotificationMessageMain>
        <NotificationMessageContent>{children}</NotificationMessageContent>
        {onConfirm && (
          <NotificationMessageButtonWrapper>
            <NotificationMessageButton onClick={onConfirm} type={type}>
              {confirmText}
            </NotificationMessageButton>
          </NotificationMessageButtonWrapper>
        )}
      </NotificationMessageMain>
    </NotificationMessageWrapper>
  );
}

NotificationMessage.defaultProps = defaultProps;

export default NotificationMessage;
